// Globals
import { useTranslation } from 'react-i18next';

// Components
import { Modal, ModalSize } from '@/components';
import { StyledTitle, StyledWrap, StyledText, StyledButtons } from './DeliveryUpdatedModalStyles';
import { Button } from '@/ui';

interface IDeliveryUpdatedModalProds {
  isOpen: boolean;
  onChangeCity: () => void;
  closeModal: () => void;
  settlementName: string;
}

const DeliveryUpdatedModal = ({ onChangeCity, isOpen, closeModal, settlementName }: IDeliveryUpdatedModalProds) => {
  const { t } = useTranslation(['orders']);

  return (
    <Modal
      visible={isOpen}
      onCancel={closeModal}
      size={ModalSize.LARGE}
      centered
      title={
        <StyledTitle>
          {t('order_delivery_updated_modal_title', {
            city: settlementName,
          })}
        </StyledTitle>
      }
    >
      <StyledWrap>
        <StyledText>{t('order_delivery_updated_modal_text')}</StyledText>
        <StyledButtons>
          <Button type="default" onClick={closeModal}>
            {t('order_delivery_updated_modal_btn_back')}
          </Button>
          <Button type="primary" onClick={onChangeCity}>
            {t('order_delivery_updated_modal_btn_change_city')}
          </Button>
        </StyledButtons>
      </StyledWrap>
    </Modal>
  );
};

export default DeliveryUpdatedModal;
